import React, {useEffect, useState, useMemo} from 'react'
import {IconButton, Modal, Button} from '@material-ui/core'
import {Close} from '@material-ui/icons'
import _ from 'lodash'

// custom components
import {Tab, TabPanel, Tabs} from '../CalendarEventPopup/Tabs'
import TabDetails from './TabDetails'
import {useGetGroupActionFields} from '../../state/groups/get-group-action-fields/hooks'
import {useGetGroupActions} from '../../state/groups/get-group-actions/hooks'
import LoadingIndicator from '../ReservationConfiguration/LoadingIcon'

import useGetReservationItemDetails from '../../state/get-reservation-item-details/reducer'
// styles
// will use styles calendar event popup

const CalendarEventDateDriveActionPopup = ({onClose, open, data = {}}) => {
  const [tabIndex, setTabIndex] = useState(0)
  const {entity_object = {}, action = {}, action_data} = data
  const entity_id = entity_object?.entity?.id || data?.entity_id
  const action_id = action?.action_id || data?.entity_action_id

  const entity_object_id = entity_object?.id || data?.entity_object_id
  const entity_key = data?.entity_key

  const {state: groupActions, call: callGetGroupActions} = useGetGroupActions()
  const {state: groupActionFields, call: callGetGroupActionFields} = useGetGroupActionFields()

  const [reservation, dispatch] = useGetReservationItemDetails()
  const {status = '', states = ''} = reservation.data || {}

  useEffect(() => {
    if (!open) return

    callGetGroupActions({group_id: entity_id, params: {action_ids: action_id}})
    callGetGroupActionFields({group_id: entity_id, action_id: action_id, all_fields: true})
  }, [entity_id, action_id, callGetGroupActionFields, callGetGroupActions, open])

  const info = useMemo(() => {
    if (_.isEmpty(groupActions.data)) return []
    // fetch action
    const _action = groupActions.data[0]

    if (_.isEmpty(groupActionFields.data)) return []
    // fetch closed fields
    let _closefields = _.toArray(groupActionFields.data)[0].filter(f => !f.is_open_field)
    let _openfields = _.toArray(groupActionFields.data)[0].filter(f => f.is_open_field)

    const _data = action_data?.values || data.action_values || {}

    let rets = [
      {
        name: _action.name,
        fields: _openfields.map(f => ({field_name: f.name, value: _data[f.key]})),
      },
    ]

    if (!!_data['field_3']) {
      const returnName = _action.change_return_name ? _action.return_name : `Return ${_action.name}`
      // map items
      rets = [
        ...rets,
        {
          name: returnName,
          fields: _closefields.map(f => ({field_name: f.name, value: _data[f.key]})),
        },
      ]
    }
    return rets
  }, [groupActions, groupActionFields, data, action_data])

  const [full_value, new_value] = useMemo(() => {
    let reservationID = ''
    const prepareValue = val => {
      let display_value
      if ((val !== null && val !== undefined && val.length > 0) || typeof val == 'number') {
        display_value = `${val},`
      } else {
        display_value = ''
      }
      return display_value
    }
    if (!_.isEmpty(data?.reservation_uid)) {
      reservationID = `#${data?.reservation_uid},`
    } else if (!_.isEmpty(data?.entity_display_name)) {
      reservationID = data?.entity_display_name
    }
    const first_name = prepareValue(data.display_name_first || entity_object?.display_name)
    const second_name = prepareValue(
      data.display_with_secondary || entity_object?.display_with_secondary
    )
    const third_name = prepareValue(data.display_name_third || entity_object?.display_name_third)
    const full_value = `${first_name} ${second_name} ${third_name}`.replace(/,\s*$/, '')
    const _new_value =
      full_value.trim() !== '' ? full_value : `${reservationID}`.replace(/,\s*$/, '')
    const _full_value =
      full_value.trim() !== '' ? full_value : `${reservationID} ${status} - ${states}`
    return [_full_value, _new_value]
  }, [data, status, states, entity_object])

  return (
    <Modal open={!!open} onClose={onClose}>
      <>
        <div
          className="c-res-mod c-calendar-event-popup"
          style={{borderLeft: `8px solid ${data.bgColor ? data.bgColor : data.color}`}}
        >
          <div
            className="c-calendar-event-popup__header"
            // style={{backgroundColor: `${data.bgColor ? data.bgColor : data.color}3f`}}
          >
            <h4 className="c-calendar-event-popup__header-title ap-typography ap-typography--lg ap-typography--light ap-ellipsis">
              <a
                style={{color: 'inherit'}}
                href={`${localStorage.parent_origin}/${entity_key}/${entity_object_id}`}
                target="_top"
                className="tooltip-header-title"
              >
                {new_value}
                <span className="tooltip-after"></span>
                <span className="tooltip-title-text">{full_value}</span>
              </a>
            </h4>
            {/* <IconButton
              className="c-calendar-event-popup__header-close ap-icon-button ap-icon-button--square"
              size="small"
              onClick={onClose}
            >
              <Close />
            </IconButton> */}
          </div>

          <div className="c-calendar-event-popup__body">
            <div className="c-calendar-event-popup__tab-wrapper">
              {info.length === 0 && <LoadingIndicator />}
              <Tabs>
                {_.map(info, (d, i) => (
                  <Tab
                    key={i}
                    active={tabIndex === i}
                    onClick={e => setTabIndex(i)}
                    style={{borderColor: `${data.bgColor ? data.bgColor : data.color}`}}
                    className={`tab-count-${info.length}`}
                  >
                    {d.name}
                  </Tab>
                ))}
              </Tabs>
              {_.map(info, (d, i) => (
                <TabPanel key={i} active={tabIndex === i}>
                  {d.fields.map((item, i) => {
                    let val =
                      typeof item.value === 'object' && !!item.value
                        ? item.value.display_name
                        : item.value

                    return (
                      <div key={i} className="ap-mb-28">
                        <p className="tab-label ap-m-0 ap-typography ap-typography--xs ap-typography--gray">
                          {item.field_name}
                        </p>
                        {!_.isNil(val) && (
                          <p className="tab-label-value ap-m-0 ap-typography ap-typography--sm">
                            {val}
                          </p>
                        )}
                        {_.isNil(val) && (
                          <p className="tab-label-value ap-m-0 ap-typography ap-typography--sm ap-typography--gray">
                            n/a
                          </p>
                        )}
                      </div>
                    )
                  })}
                </TabPanel>
              ))}
            </div>
          </div>
          <div className="c-calendar-event-popup__footer">
            <Button
              onClick={onClose}
              style={{width: 80, textTransform: 'capitalize'}}
              // className="cancel-btn ap-button ap-button--text font-bold color-303A52 mt--1"
            >
              Close
            </Button>
          </div>
        </div>
      </>
    </Modal>
  )
}

export default CalendarEventDateDriveActionPopup
